export function isHeadOfficeUser(role = '') {
    const organizationRoles = ['HEAD_OFFICE', 'ORGANIZATION'];

    return organizationRoles.includes(role);
}